import {
  MyTimesheetAdminSettingsPage,
  MyTimesheetExaminerDashboardPage,
  MyTimesheetExaminerUserRequestsPage,
  MyTimesheetMyRequestsDashboardPage,
  MyTimesheetMyRequestsPage,
  MyTimesheetRequestsByContractPage,
  MyTimesheetUserRequestPage,
  MyTimesheetViewUserRequestsPage,
} from "my-timesheet/pages";

export const myTimesheetMyRequestsPageRoutePath = "/my-timesheet/my-requests";
export const myTimesheetMyRequestsDashboardPageRoutePath =
  "/my-timesheet/my-requests-dashboard";
export const myTimesheetExaminerDashboardPageRoutePath =
  "/my-timesheet/examiner-dashboard";
export const myTimesheetUserRequestsPageRoutePath =
  "/my-timesheet/user-requests";
export const myTimesheetUserRequestsViewPageRoutePath =
  "/my-timesheet/user-requests-view";
export const myTimesheetUserRequestByIdPageRoutePath =
  "/my-timesheet/user-request/:id";
export const myTimesheetUserRequestByContractPageRoutePath =
  "/my-timesheet/user-requests/:contract";
export const mySheetAdminSettingsPageRoutePath = "/my-timesheet/admin/settings";

export const buildMyTimesheetUserRequestByIdPageRoutePath = (id: string) =>
  `/my-timesheet/user-request/${id}`;
export const buildMyTimesheetUserRequestByContractPageRoutePath = (
  contract: string,
) => `/my-timesheet/user-requests/${contract}`;

export const myTimesheetRoutes = [
  {
    id: "myTimesheetMyRequestsPageRoute",
    path: myTimesheetMyRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyTimesheetMyRequestsPage,
    roles: ["MyTimesheet.user"],
  },
  {
    id: "myTimesheetMyRequestsDashboardPageRoute",
    path: myTimesheetMyRequestsDashboardPageRoutePath,
    exact: true,
    private: true,
    component: MyTimesheetMyRequestsDashboardPage,
    roles: ["MyTimesheet.user"],
  },
  {
    id: "myTimesheetExaminerDashboardPageRoute",
    path: myTimesheetExaminerDashboardPageRoutePath,
    exact: true,
    private: true,
    component: MyTimesheetExaminerDashboardPage,
    roles: ["MyTimesheet.examiner", "MyTimesheet.viewer"],
  },
  {
    id: "myTimesheetUserRequestsPageRoute",
    path: myTimesheetUserRequestsPageRoutePath,
    exact: true,
    private: true,
    component: MyTimesheetExaminerUserRequestsPage,
    roles: ["MyTimesheet.examiner"],
  },
  {
    id: "myTimesheetUserRequestsViewPageRoute",
    path: myTimesheetUserRequestsViewPageRoutePath,
    exact: true,
    private: true,
    component: MyTimesheetViewUserRequestsPage,
    roles: ["MyTimesheet.viewer"],
  },
  {
    id: "myTimesheetUserRequestByIdPageRoute",
    path: myTimesheetUserRequestByIdPageRoutePath,
    exact: true,
    private: true,
    component: MyTimesheetUserRequestPage,
    roles: ["MyTimesheet.examiner"],
  },
  {
    id: "myTimesheetUserRequestByContractPageRoute",
    path: myTimesheetUserRequestByContractPageRoutePath,
    exact: true,
    private: true,
    component: MyTimesheetRequestsByContractPage,
    roles: ["MyTimesheet.examiner"],
  },
  {
    id: "mySheetAdminSettingsPageRoute",
    path: mySheetAdminSettingsPageRoutePath,
    exact: true,
    private: true,
    component: MyTimesheetAdminSettingsPage,
    roles: ["MyTimesheet.admin"],
  },
];
